import * as _ from "lodash";
import * as moment from "moment";
import { match } from "react-router";
import { IChild } from "src/share/types/case/children";
import { initialChild } from "./case/children";
import { IMonthOption } from "../components/MonthlyFilter/MonthlyFilter";
import { initialCase, ICase } from "./case/case";
import { IAuthState } from "src/modules/Auth/store/types";
import { IMetricsContent } from "./alert";
import { History, Location } from 'history';

export interface IRequestGeoSearch {
  page: number;
  size: number;
  filterByAgency?: string;
  range?: { lte: number; gte: number };
}

export interface IResponseGeoSearch {
  results: IGeoSearch[];
  total: number;
}

export interface IGeoSearch {
  id: string;
  radius: number;
  date: number;
  caseId: string;
  personType: "child" | "abductor";
  personId: string;
  searchName?: string;
  manual?: boolean;
  center: {
    lat: number;
    lng: number;
  };
  dateRange: {
    lte: number;
    gte: number;
  };
  person: {
    childId?: string;
    abductorId?: string;
    fullName: string;
  };
  agencyCode: string;
}

interface IGeoSearchResult {
  results: number;
  center: { lat: number; lng: number };
  dateRange: { gte: number; lte: number };
  radius: number;
  caseId?: string;
  agencyCode: string;
  contactInformation: string;
  state: string;
  city: string;
  country: string;
  children?: IChild[];
  openDate: number;
  missingDate: number;
  circumstances: string;
  faces: number;
  matches: number;
  personId?: string;
  manual?: boolean;
  requestedImageURL?: string;
}
export interface IGeoSearchQuery {
  caseId: string;
  center: { lat: number; lng: number };
  dateRange: { gte: number; lte: number };
  radius: string;
}

export const initialGeoSearchResult: IGeoSearchResult = {
  results: 0,
  center: { lat: 0, lng: 0 },
  dateRange: { gte: 0, lte: 0 },
  radius: 0,
  caseId: "",
  agencyCode: "",
  contactInformation: "",
  state: "",
  city: "",
  manual: true,
  country: "",
  children: [_.cloneDeep(initialChild)],
  openDate: new Date().getTime(),
  missingDate: new Date().getTime(),
  circumstances: "",
  faces: 0,
  matches: 0,
  personId: ""
};
export interface IGSResultProps {
  match: match<{ searchId: string }>;
  history: History;
}
export interface IGSResultState {
  processedImages: {
    total: number;
    uploaded: number;
    percentage: number;
  };
  processedImagesInterval: any;
  isProcessing: boolean;
  isLoadingInfo: boolean;
  isLoadingImages: boolean;
  isFetchingImages: boolean;
  page: number;
  size: number;
  result: IGeoSearchResult;
  images: any[];
  loadedImages: any[];
}
export interface IGeoSearchViewState {
  loading: boolean;
  page: number;
  pages: number;
  size: number;
  fetchingData: boolean;
  filterByAgency?: string;
  searches: {
    results: IGeoSearch[];
    total: number;
  };
  options?: IMonthOption[];
  selected?: IMonthOption;
}

export const initialGeoSearchViewState: IGeoSearchViewState = {
  loading: true,
  page: 0,
  pages: 0,
  size: 10,
  fetchingData: false,
  searches: {
    results: [],
    total: 0
  }
};

export interface ILocationCenter {
  lat: number;
  lng: number;
}
export interface ISearchRequest {
  radius: number;
  caseId: string;
  personType: "child" | "abductor";
  personId: string;
  center: ILocationCenter;
  dateRange: {
    lte: number;
    gte: number;
  };
}
export interface IManualSearchRequest {
  radius: number;
  center: ILocationCenter;
  dateRange: {
    lte: number;
    gte: number;
  };
  image: string;
}
export interface IGeoSearchChild {
  id: string;
  name: string;
  images: string[];
}

export interface IGeoSearchProps {
  location: Location
  match: match<{ caseId?: string; alertId?: string }>;
  history: History;
  auth: IAuthState;
}

export interface IGeoSearchState {
  loading: boolean;
  location: string;
  isCaseSelected: boolean;
  isLocationSelected: boolean;
  radius: number;
  defaultLocation: ILocationCenter;
  dateRange: {
    startDate: moment.Moment | null;
    endDate: moment.Moment | null;
    focus: "startDate" | "endDate" | null;
  };
  caseInfo: ICase;
  children: IGeoSearchChild[];
  selectedChild: string;
  selectedLocation: ILocationCenter;
}

export const initialDefaultLocation: ILocationCenter = {
  lat: 9.928069,
  lng: -84.090729
};

export const initialGeoSearchState: IGeoSearchState = {
  loading: false,
  defaultLocation: { ...initialDefaultLocation },
  radius: 1,
  location: "",
  isLocationSelected: false,
  isCaseSelected: false,
  dateRange: {
    startDate: null,
    endDate: null,
    focus: null
  },
  selectedChild: "",
  selectedLocation: {
    lat: 0,
    lng: 0
  },
  caseInfo: {
    ..._.cloneDeep(initialCase),
    children: []
  },
  children: []
};

export interface IGeoSearchStats {
  dailySearches: IMetricsContent[];
  totalResultsImages: number;
  totalSearches: number;
  agenciesSearches: IMetricsContent[];
  agenciesPhotosResults: IMetricsContent[];
  totalMatches: number;
  totalFacesDetected: number;
  totalAgencies: number;
  totalImagesWithFaces: number;
}

export const initialGeoSearchStats = {
  dailySearches: [],
  totalResultsImages: 0,
  totalSearches: 0,
  agenciesSearches: [],
  agenciesPhotosResults: [],
  agenciesMatches: [],
  totalMatches: 0,
  totalFacesDetected: 0,
  totalAgencies: 0,
  totalImagesWithFaces: 0
};



// WEBPACK FOOTER //
// ./src/share/types/geoSearch.ts